/**
 * Con HashRouter, los query params pueden ir en el fragmento: #/ruta?a=1&b=2
 * (location.search a veces viene vacío). Unifica lectura para mail / enlaces externos.
 */
export function getHashRouterSearchString(location) {
    if (location.search && location.search.length > 1) {
        return location.search;
    }
    if (typeof window === 'undefined') return '';
    const hash = window.location.hash || '';
    const q = hash.indexOf('?');
    if (q >= 0) return hash.slice(q);
    return '';
}
